import BannerWarning from "./BannerWarning";
export default BannerWarning